<h2 mat-dialog-title>Edit Contract: {{ data.contract.name || data.contract.id }}</h2>

<mat-dialog-content>
  <form [formGroup]="patchForm" class="patch-form">
    <p class="info-message">
      Toggle the fields you want to update. All parameters are optional.
    </p>

    <!-- Name Section -->
    <div class="parameter-section">
      <div class="section-header">
        <mat-slide-toggle formControlName="enableName" color="primary">
          Update Name
        </mat-slide-toggle>
      </div>

      @if (isNameEnabled()) {
      <div class="section-content">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="Enter contract name">
          <mat-icon matPrefix>label</mat-icon>
          @if (patchForm.controls.name.hasError('required') && patchForm.controls.name.touched) {
          <mat-error>Name is required when enabled</mat-error>
          }
        </mat-form-field>
      </div>
      }
    </div>

    <!-- Note Section -->
    <div class="parameter-section">
      <div class="section-header">
        <mat-slide-toggle formControlName="enableNote" color="primary">
          Update Note
        </mat-slide-toggle>
      </div>

      @if (isNoteEnabled()) {
      <div class="section-content">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Note</mat-label>
          <textarea matInput formControlName="note" placeholder="Enter a note" rows="2"></textarea>
          <mat-icon matPrefix>notes</mat-icon>
        </mat-form-field>
      </div>
      }
    </div>

    <!-- Target Coins Section -->
    <div class="parameter-section">
      <div class="section-header">
        <mat-slide-toggle formControlName="enableTargetCoins" color="primary">
          Update Target Coins
        </mat-slide-toggle>
      </div>

      @if (isTargetCoinsEnabled()) {
      <div class="section-content">
        <mat-form-field appearance="outline" class="w-full">
          <mat-label>Target Coins</mat-label>
          <input matInput formControlName="targetCoins" type="number" min="1" placeholder="Enter target coins">
          <mat-icon matPrefix>monetization_on</mat-icon>
          @if (patchForm.controls.targetCoins.hasError('required') && patchForm.controls.targetCoins.touched) {
          <mat-error>Target coins is required when enabled</mat-error>
          }
          @if (patchForm.controls.targetCoins.hasError('min')) {
          <mat-error>Must be at least 1</mat-error>
          }
        </mat-form-field>
      </div>
      }
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()" [disabled]="loading || patchForm.invalid">
    @if (loading) {
    Saving...
    } @else {
    Save Changes
    }
  </button>
</mat-dialog-actions>
